import React from "react";
import {
  PERMISSION_ACTIONS,
  toggleScreenPermission,
} from "../../utils/ccScreenPermissions";

const ScreenPermissionsMatrix = ({
  screenDefs = [],
  permissions = {},
  disabled = false,
  onChange,
  theme,
}) => {
  const borderClass =
    theme === "dark"
      ? "border-gray-600"
      : theme === "high-contrast"
        ? "border-gray-800"
        : "border-gray-200";

  if (screenDefs.length === 0) {
    return <p className="text-sm text-gray-500">Loading screens…</p>;
  }

  return (
    <div className={`border rounded-lg overflow-hidden ${borderClass}`}>
      <div className="overflow-x-auto max-h-96 overflow-y-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 sticky top-0 z-10">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-600">
                Screen
              </th>
              {PERMISSION_ACTIONS.map((action) => (
                <th
                  key={action.key}
                  className="px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide text-gray-600 whitespace-nowrap"
                >
                  {action.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 bg-white">
            {screenDefs.map((screen) => {
              const screenCode = String(screen.screenCode || "").toUpperCase();
              const row = permissions[screenCode] || {
                canView: false,
                canCreate: false,
                canUpdate: false,
                canDelete: false,
              };
              const isViewEnabled = row.canView;

              return (
                <tr key={screenCode} className="hover:bg-gray-50">
                  <td className="px-3 py-3 align-top">
                    <div className="font-medium text-gray-800">{screen.screenName || screenCode}</div>
                    {screen.description ? (
                      <div className="text-xs text-gray-500 mt-0.5">{screen.description}</div>
                    ) : null}
                  </td>
                  {PERMISSION_ACTIONS.map((action) => {
                    const isRead = action.key === "canView";
                    const isDisabled = disabled || (!isRead && !isViewEnabled);
                    const checked = Boolean(row[action.key]);

                    return (
                      <td key={action.key} className="px-3 py-3 text-center align-middle">
                        <input
                          type="checkbox"
                          className="w-4 h-4"
                          checked={checked}
                          disabled={isDisabled}
                          onChange={() =>
                            onChange(toggleScreenPermission(permissions, screenCode, action.key))
                          }
                          aria-label={`${screen.screenName || screenCode} ${action.label}`}
                        />
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ScreenPermissionsMatrix;
